var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.value.length,
        label: _vm.label,
        half: _vm.half,
      },
    },
    [
      _vm.selectedOption !== undefined
        ? _c(
            "div",
            {
              staticClass:
                "boss-layout boss-layout-start boss-layout-gap-large",
              attrs: { "data-test": "prefecture-option" },
            },
            _vm._l(_vm.prefectureOptions, function (option, i) {
              return _c(
                "label",
                {
                  key: i,
                  staticClass: "pega-input",
                  attrs: { "data-test": "label-" + i },
                },
                [
                  _c("input", {
                    staticClass: "boss-input-checkbox",
                    attrs: { "data-test": "radio-" + i, type: "radio" },
                    domProps: {
                      checked: _vm.selectedOption === option.key,
                      value: option.key,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit(
                          "update:selectedOption",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(_vm._s(option.label) + "\n    "),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.containWorkPrefecturesNonHopeUser !== undefined
        ? _c(
            "label",
            {
              staticClass: "boss-checkbox",
              attrs: { "data-test": "use-option-checkbox" },
            },
            [
              _c("input", {
                staticClass: "boss-input-checkbox",
                attrs: { type: "checkbox", "data-test": "check-box" },
                domProps: { checked: _vm.containWorkPrefecturesNonHopeUser },
                on: {
                  change: function ($event) {
                    return _vm.$emit(
                      "update:containWorkPrefecturesNonHopeUser",
                      $event.target.checked
                    )
                  },
                },
              }),
              _vm._v("希望勤務地が未入力の会員を含む\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAnnotationLabel
        ? _c(
            "label",
            {
              staticClass: "boss-annotation-text",
              attrs: { "data-test": "show-annotation" },
            },
            [
              _vm._v(
                "\n    ※プリセットでは、勤務地に近い地域が選択されています。\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.prefecturesMaster.length > 0
        ? _c("select-modal-button", {
            attrs: {
              "master-data": _vm.prefecturesMaster,
              "selected-items": _vm.value.map(function (n) {
                return { id: n, experience: "" }
              }),
              title: "都道府県",
              suffix: "prefectures",
              "is-wrap-category": true,
              "is-ellipsis": true,
              "data-test": "modal",
              "can-accordion": true,
            },
            on: {
              "update-modal-checked-ids": function (value) {
                return _vm.update(value)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }